import { render, staticRenderFns } from "./ConfirmRejectBtns.vue?vue&type=template&id=6738f51e"
import script from "./ConfirmRejectBtns.vue?vue&type=script&lang=js"
export * from "./ConfirmRejectBtns.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRejectBtns.vue?vue&type=style&index=0&id=6738f51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports